
export default {
  name: 'SpainFlag',
};
